(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-veluxa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.av').forEach(function (root) {
        if (root.dataset.avInit) return;
        root.dataset.avInit = '1';
        var items = root.querySelectorAll('.av-reveal');
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        root.classList.add('av-js');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
        items.forEach(function (el) { io.observe(el); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-animated"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.fq').forEach(function (root) {
        if (root.dataset.fqInit) return;
        root.dataset.fqInit = '1';
        var list = root.querySelector('.fq-list');
        var items = Array.prototype.slice.call(root.querySelectorAll('.fq-item'));
        if (list) {
          list.addEventListener('toggle', function (e) {
            if (list.dataset.single !== 'true') return;
            var t = e.target;
            if (!t.open) return;
            items.forEach(function (d) { if (d !== t) d.open = false; });
          }, true);
        }
        var input = root.querySelector('.fq-search__input');
        var empty = root.querySelector('.fq-empty');
        if (input) {
          input.addEventListener('input', function () {
            var q = input.value.trim().toLowerCase();
            var shown = 0;
            items.forEach(function (d) {
              var match = !q || d.textContent.toLowerCase().indexOf(q) !== -1;
              d.hidden = !match;
              if (match) shown++;
            });
            if (empty) empty.hidden = shown > 0;
          });
        }
        var reveal = root.querySelectorAll('.fq-reveal');
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        root.classList.add('fq-js');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
        reveal.forEach(function (el) { io.observe(el); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floppies-faq"]) return;
  try {
    
  if (!customElements.get('floppies-faq-list')) {
    customElements.define(
      'floppies-faq-list',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('toggle', (e) => {
            if (this.dataset.single !== 'true') return;
            const t = e.target;
            if (!t.open) return;
            this.querySelectorAll('details[open]').forEach((d) => { if (d !== t) d.open = false; });
          }, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.hh').forEach(function (root) {
        if (root.dataset.hhInit) return;
        root.dataset.hhInit = '1';
        if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        root.classList.add('hh-js');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
        root.querySelectorAll('.hh-reveal').forEach(function (el) { io.observe(el); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.hv').forEach(function (root) {
        if (root.dataset.hvInit) return;
        root.dataset.hvInit = '1';
        var vids = root.querySelectorAll('video');
        vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
        if (!('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
          });
        }, { threshold: 0.25 });
        vids.forEach(function (v) { io.observe(v); });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizon-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hz-faq-list')) {
    customElements.define('hz-faq-list', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('toggle', (e) => {
          if (this.dataset.single !== 'true') return;
          const t = e.target;
          if (!t.open) return;
          this.querySelectorAll('details[open]').forEach((d) => { if (d !== t) d.open = false; });
        }, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
